import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import keyBy from 'lodash-es/keyBy';

import type { Note, NoteCreatorData, NoteQueryParams } from './types';

export interface NotesState {
  entities: Record<string, Note>;
  noteCreatorData: NoteCreatorData | null;
}

export const initialState: NotesState = {
  entities: {},
  noteCreatorData: null,
};

export const fetchNotes = createAsyncThunk<Note[], NoteQueryParams>(
  'notes/fetchNotes',
  async (params) => {
    const response = await axios.get<PaginatedResults<Note>>('/notes/', {
      params: { ...params, page_size: 1000 },
    });
    return response.data.results;
  }
);

const notesSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {
    createNoteSuccess(state, action: PayloadAction<Note>) {
      state.entities[action.payload.id] = action.payload;
    },
    openNoteCreator(state, action: PayloadAction<NoteCreatorData>) {
      state.noteCreatorData = action.payload;
    },
    closeNoteCreator(state) {
      state.noteCreatorData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchNotes.fulfilled, (state, action) => {
      if (action.payload.length === 0) {
        return;
      }
      state.entities = { ...state.entities, ...keyBy(action.payload, 'id') };
    });
  },
});

export const { createNoteSuccess, openNoteCreator, closeNoteCreator } =
  notesSlice.actions;

export const reducer = notesSlice.reducer;

export default notesSlice;
